interface IGetMortgageOffersTitleParams {
  hasBanks: boolean;
  hasMortgagePromos: boolean;
}

export function getSectionTitle({ hasBanks, hasMortgagePromos }: IGetMortgageOffersTitleParams): string {
  if (hasBanks && hasMortgagePromos) {
    return 'Ипотечные предложения и аккредитованные банки';
  }

  if (hasBanks) {
    return 'Аккредитованные банки';
  }

  return 'Ипотечные предложения';
}
